import type { darkTheme } from './dark-theme';
import type { lightTheme } from './light-theme';

export enum BaseControlColor {
  Primary = 'primary',
  Secondary = 'secondary',
  SystemRegular = 'systemRegular',
  SystemLight = 'systemLight',
  CustomDark = 'customDark',
  Custom100 = 'custom100',
  Custom300 = 'custom300',
  Custom400 = 'custom400',
  Custom500 = 'custom500',
  Transparent = 'transparent',
}

export enum Themes {
  Light = 'light',
  Dark = 'dark',
}

type CompareTypes<T, U> = T extends U ? (U extends T ? T : never) : never;

export type Theme = CompareTypes<typeof lightTheme, typeof darkTheme>;
